export const outcomesReducer = (
	state = {
		listData: [],
		countData: 0
	},
	action
) => {
	switch (action.type) {
		case "OUTCOMES_LIST":
		case "OUTCOMES_SUCCESS":
			return {
				...state,
				listData: action.payload.list,
				countData: action.payload.count,

			};

		default:
			return state;
	}
};
